import type { LiveKitLayoutActiveAssetInput } from '@/features/live/types';
import type { VideoLayoutState } from '@/components/pages/live/admin/VideoLiveView';

/**
 * Asset vidéo poussé dans les métadonnées LiveKit. Sans l'état de lecture, le compositor
 * n'émet aucun ordre et laisse la vidéo en pause : la reprise doit toujours le transmettre.
 */
export function buildVideoActiveAsset(
  url: string,
  state: VideoLayoutState | null | undefined,
): LiveKitLayoutActiveAssetInput {
  if (!state) {
    return { type: 'VIDEO', url };
  }
  return {
    type: 'VIDEO',
    url,
    paused: state.paused,
    muted: state.muted,
    currentTime:
      Number.isFinite(state.currentTime) && state.currentTime > 0 ? state.currentTime : 0,
  };
}
